import {Routes} from '@angular/router';
import {canActivateGuard} from '../../../guards/can-activate-guard';
import {PERMISSION} from '@generated-backend-types';
import {EditComponent as OverviewEditComponent} from '../overview/edit/edit.component';
import {EditComponent as EntryEditComponent} from './edit/edit.component';
import {TimeTrackingEntryService} from '../../../services/api/time-tracking/time-tracking-entry.service';


export const routes: Routes = [
  {
    path: '',
    component: OverviewEditComponent,
    canActivate: [canActivateGuard],
    data: {
      allPermissionsNeeded: [PERMISSION.TIMETRACKING_TIMETRACKINGENTRY_READ_ALL],
      breadcrumb: [
        {
          label: 'authenticated.time_tracking.entries.index.breadcrumb',
          translate: true,
          route: '/time-tracking/entries',
        },
      ]
    }
  },
  {
    path: 'add',
    component: EntryEditComponent,
    canActivate: [canActivateGuard],
    data: {
      allPermissionsNeeded: [PERMISSION.TIMETRACKING_TIMETRACKINGENTRY_CREATE_ALL],
      breadcrumb: [
        {
          label: 'authenticated.time_tracking.entries.index.breadcrumb',
          translate: true,
          route: '/time-tracking/entries',
        },
        {label: 'authenticated.time_tracking.entries.create.breadcrumb', translate: true,},
      ]
    }
  },
  {
    path: ':id',
    component: EntryEditComponent,
    canActivate: [canActivateGuard],
    resolve: {
      entry: TimeTrackingEntryService,
    },
    data: {
      allPermissionsNeeded: [PERMISSION.TIMETRACKING_TIMETRACKINGENTRY_UPDATE_ALL],
      breadcrumb: [
        {
          label: 'authenticated.time_tracking.entries.index.breadcrumb',
          translate: true,
          route: '/time-tracking/entries',
        },
        {dynamic: true, dataKey: 'entry.date', route: '/time-tracking/entries/:id'},
        {label: 'authenticated.time_tracking.entries.edit.breadcrumb', translate: true,},
      ]
    }
  },
];
